import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { VideoType } from "@swo/shared";
import React from "react";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import cn from "classnames";
import { PDPImagesGridImageT } from "./PDP_Gallery/types";

export const PDPMobileGalleryIndicator: ReactTFC<{
  visibleIdx: number;
  elements: Array<PDPImagesGridImageT | VideoType>;
  setVisibleIdx: React.Dispatch<React.SetStateAction<number>>;
}> = props => {
  if (props.elements.length < 2) {
    return null;
  }

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        flex-wrap: nowrap;
        gap: 4px;

        position: absolute;
        bottom: 10px;
        z-index: 2;
        left: 0;
        width: 100%;

        .button {
          display: block;
          padding: 10px;

          width: 32px;
          height: 32px;
        }

        .image,
        .video {
          display: block;

          width: 100%;
          height: 100%;

          background-color: ${CSS_COLORS.White};

          border-radius: 100%;
          border-width: 1px;
          border-style: solid;
          border-color: ${CSS_COLORS.Green};
        }

        .selected {
          .image,
          .video {
            background-color: ${CSS_COLORS.Green};
          }
        }
      `}
    >
      {props.elements.map((element, idx) => {
        return (
          <button
            key={JSON.stringify(element)}
            className={cn({ selected: idx === props.visibleIdx }, "button")}
            onClick={() => props.setVisibleIdx(idx)}
          >
            {element.__typename === "Image" ? <span className={"image"} /> : <span className={"video"} />}
          </button>
        );
      })}
    </div>
  );
};
